const printableProps = <T extends Record<string, unknown>>(
  props: T | T[]
): string =>
  JSON.stringify(props)
    .replace(/[{"}]/g, '')
    .replace(/[,]/g, ' ')
    .replace(/[:]/g, ': ') || 'default';

export { printableProps };
